import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../css/subPages.css";

import Header from "./Header";
import StartToday from "./StartToday";
import Footer from "../../components/Footer";

export default function KeyReasons() {
  return (
    <>
      <Header pageSectionId="informationSection" />
      <Container className="subPageContainer">
        <Row className="pt-3 mb-3">
          <Col sm={12} className="text-center">
            <div className="subPageHeadingContainer">
              <h3 className="subPageHeadingText">
                KEY REASONS TO REFINANCE WHEN DIVORCING
              </h3>
            </div>
          </Col>
        </Row>
        <Row className="pt-3 mb-3">
          {/* <Col sm={12} className="mb-3">
                        <h5 className="subPageText">
                            A Certified Divorce Lending Professional (CDLP&#174;) coupled with a
                            licensed mortgage loan officer, understands the connection between divorce,
                            family law, and mortgage financing. A CDLP&#174; brings in financial
                            knowledge and expertise, and provides you with the following benefits:
                        </h5>
                    </Col> */}
          <Col className="mb-3">
            <ol className="listItems">
              <li className="mb-3">
                <h5 className="subPageListItems">
                  <b>1. Remove liability for the mortgage</b><br /><br />
                  Even if your spouse buys you out of the home, you may still be
                  liable for the mortgage unless the house is sold, mortgage is
                  paid off, or the mortgage is refinanced to remove your name.
                </h5>
              </li>
              <li className="mb-3">
                <h5 className="subPageListItems">
                  <b>2. Equity buyout</b><br /><br />
                  If you decide to keep the home and pay the spouse for his/her
                  share of equity in the home, a cash-out refinance may
                  facilitate in getting the funds for equity buyout.
                </h5>
              </li>
              <li className="mb-3">
                <h5 className="subPageListItems">
                  <b>3. Utilize your home equity</b><br /><br />
                  Use your home equity to get cash out for other purposes such
                  as urgent expenses, debt consolidation, repairs/renovation,
                  emergency cash reserve fund, or to pay attorney fees.
                </h5>
              </li>
              <li className="mb-3">
                <h5 className="subPageListItems">
                  <b>4. Lower the mortgage payment</b><br /><br />
                  A lower mortgage payment can provide you more room to
                  accommodate higher costs post the divorce.
                </h5>
              </li>
              <li className="mb-3">
                <h5 className="subPageText">
                  <b>5. Get a fixed rate mortgage</b><br /><br />
                  With a fixed rate mortgage, you won’t have to worry about
                  fluctuating interest rates. Enjoy the financial freedom and
                  peace of mind you get from predictable mortgage payments.
                </h5>
              </li>

            </ol>
          </Col>
        </Row>
        <StartToday />
      </Container>
      <Footer />
    </>
  );
}
